import React,{useContext} from "react";

const ThemeContext = React.createContext('light');

function ThemedButton(){
    const theme = useContext(ThemeContext);
    return <button className = {theme}>Button</button>
}

export default ThemedButton;